import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../../utils/decorators";
import BaseModalView from "./base-modal-view"


@Options({
    template: require("../templates/audio-video-view.njk"),
})
export default class AudioVideoView extends Marionette.View<Backbone.Model>{
    positions = [
        {time:1},
        {time:10},
        {time:25},
        {time:50},
        {time:75},
        {time:90},
        {time:99}
    ];
    lastEventAction = "";
    timeoutObj;
    player;
    onBeforeDetach() {
        this.$el.find("iframe").attr("src","#");

        this.player.off("play");
        this.player.off("pause");
        this.player.off("seeked");
        this.player.off("timeupdate");
        this.player.off("ended");
    }
    onRender(){
        this.player = this.$el.find("video, audio")

        this.player.on("play", $.proxy(this.onPlayerState, this));
        this.player.on("pause", $.proxy(this.onPlayerState, this));
        this.player.on("seeked", $.proxy(this.onPlayerState, this));
        this.player.on("timeupdate", $.proxy(this.onTick, this));
        this.player.on("ended", $.proxy(this.onPlayerState, this));
    }
    onTick(evt){
        let targ = evt.currentTarget;
        let percent = targ.currentTime/targ.duration *100;
        let scope = this;
        $.each(this.positions, function(i, item){
            if(!item["past"]){
                if(item.time<percent){
                    item["past"] = true;
                    scope.trackEvent("Reached " + item.time + "%", true);
                }
            }
        });
    }
    trackEvent(action, timeEvent=false){
        if(!timeEvent){
            if(
                (this.lastEventAction=="pause" && action=="seeked")//if you get a "seek" right after a pause, suppress the pause
                ||
                (this.lastEventAction=="pause" && action=="ended")//if you get a "ended" right after a pause, suppress the pause
            ){
                clearTimeout(this.timeoutObj);
            }
            // console.log("this.lastEventAction: " + this.lastEventAction + "  action==" + action)
            if(
                (this.lastEventAction=="seeked" && action=="play")
                ||
                (this.lastEventAction=="seeked" && action=="seeked")
            ){
                // console.log("killed action above");
                return;
            }
            this.lastEventAction = action;
            if(this.player.seeking) return;
        }
                
        var dataLayer = window["dataLayer"] = window["dataLayer"] || [];
        let data = this.$el.data();
        if(this.model.attributes.jsSlideType=="native_video"){
            this.makeTimeout({
                event: "videoTracking",
                videoAction: action,//e.g. ‘Click to Play’ or ‘Reach 25%’ or ‘Pause’
                videoTitle: this.model.attributes.jsTitle, // e.g. ‘Oneohtrix Point Never – The Station’
                // videoURL: <video url>, // e.g. ‘youtube.com/watch?v=Wk_AOIwGeOs
                videoType: this.model.attributes.jsSlideType // e.g. ‘YouTube’ or ‘Vimeo’
            });
        }else if(this.model.attributes.jsSlideType=="native_audio"){
            this.makeTimeout({
                event: "audioTracking",
                audioAction: action,//e.g. ‘Click to Play’ or ‘Reach 25%’ or ‘Pause’
                audioTitle: this.model.attributes.jsTitle, // e.g. ‘Oneohtrix Point Never – The Station’
                // videoURL: <video url>, // e.g. ‘youtube.com/watch?v=Wk_AOIwGeOs
                audioType: this.model.attributes.jsSlideType // e.g. ‘YouTube’ or ‘Vimeo’
            });
        }

    }
    makeTimeout(obj){
        this.timeoutObj = setTimeout($.proxy(this.dataPush, this), 200, obj);
    }
    dataPush(obj){
        var dataLayer = window["dataLayer"] = window["dataLayer"] || [];
        let data = this.$el.data();
        dataLayer.push(obj);
    }
    onPlayerState(evt){
        this.trackEvent(evt.type);           

    }
}



// WEBPACK FOOTER //
// ./@modules/modals/views/audio-video-view.ts